import { isNull, isUndefined } from "lodash-es";
import { BookItemType } from "src/app/backend/models/book/book-item";
import { MedicalServiceLight } from "src/app/backend/models/medical-service";
import { RateTableLight } from "src/app/backend/models/rate-table/rate-table";

function modifierPhysiciansPercentage(
  rateTable: RateTableLight | undefined,
  modifierKey:
    | "serviceModifier"
    | "productModifier"
    | "drugModifier"
    | "parapharmaceuticalModifier"
): number {
  return rateTable?.[modifierKey]?.physiciansPercentage ?? 0;
}

export function resolvePhysiciansPercentage({
  bookItemType,
  rateTable,
  medicalService
}: {
  bookItemType: BookItemType;
  rateTable: RateTableLight | undefined;
  medicalService?: MedicalServiceLight | undefined;
}): number {
  switch (bookItemType) {
    case BookItemType.MEDICAL_SERVICE: {
      if (
        isUndefined(medicalService?.physiciansPercentage) ||
        isNull(medicalService?.physiciansPercentage)
      ) {
        return modifierPhysiciansPercentage(rateTable, "serviceModifier");
      }

      return medicalService.physiciansPercentage;
    }
    case BookItemType.DRUG_ASSIGNMENT: {
      return modifierPhysiciansPercentage(rateTable, "drugModifier");
    }
    case BookItemType.PRODUCT_SALE: {
      return modifierPhysiciansPercentage(rateTable, "productModifier");
    }
    case BookItemType.PARAPHARMACEUTICAL: {
      return modifierPhysiciansPercentage(
        rateTable,
        "parapharmaceuticalModifier"
      );
    }
    case BookItemType.ADVANCE_PAYMENT: {
      return 0;
    }
    default: {
      return 0;
    }
  }
}
